import axios from 'axios';
import { RRule, RRuleSet, rrulestr } from 'rrule'
import store from '../store/store'

const moment = require('moment')

// 20260522 -- ZWS -- Document local-midnight date storage convention (see migrateDates.js for migration)
// DATE/TIME STORAGE CONVENTION
// task date fields (due, start):
//   Local-midnight epoch ms.
//   Write: moment(dateString, 'YYYY-MM-DD').valueOf()  — moment defaults to local TZ
//   Read:  moment(epochMs).format('MM/DD/YYYY')        — moment displays local TZ
//   Filter boundary: moment().startOf('day').valueOf() — local midnight
//   Mobile equivalent: DateTimeConverter.dateToEpoch() / fromDateEpoch()
//
// task time fields (duetime, starttime):
//   Local-datetime epoch ms anchored to the same calendar day as the sibling date field.
//   calculateDynamicFields() re-anchors duetime→due and starttime→start.
//   Mobile equivalent: DateTimeConverter.timeToEpoch() / fromTimeEpoch()
//
// absolute timestamps (completedDate, added, modified, remindDate):
//   Standard epoch ms, timezone-neutral. Display in local TZ via moment(epochMs).format(...).
//import UUIDService from '../services/UUIDService'
import {v4 as UUIDService} from 'uuid';

const url = '/api/v1/external/tasks';
const url_v2 = '/api/v2/external/task';
const url_v3 = '/api/v3';

const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
const months2 = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']

const createdBy = ['Main website']
  

class TaskService {
    
    static addTask(task, token) {
        
        let tasks = []; 

        tasks.push(task);

        return this.addTasks(tasks, token)
    }
    
    static addTasks(tasks, token) {
        
        return axios.post(url, {
            data: tasks
        },
        {
            headers: {Authorization: `Bearer ${token}`}
        })
        
    }

    static calculateDynamicFields(task) {

        // Ensure the date of the duetime aligns with the due[date].

        if(typeof task.duetime != 'undefined' && task.duetime !== null && task.duetime > 0) {

            // Only perform calculation if both duetime and due are populated

            if(typeof task.due != 'undefined' && task.due !== null && task.due > 0) {

                let tempDateString = TaskService.getStringFromMillis(task.due, 'MM/DD/YYYY')
                // 20260604 -- Copilot (Claude Sonnet 4.6) -- Omit ZZ so Moment uses the target date's DST offset, not the stale one
                let tempTimeString = TaskService.getStringFromMillis(task.duetime, 'HH:mm a')

                // 20260128 -- Copilot (Claude Sonnet 4.5) -- Removed debug console.log

                task.duetime = TaskService.getMillisFromString(tempDateString + ' ' + tempTimeString, false, 'MM/DD/YYYY HH:mm a')

            }
        }

        // 20260603 -- Copilot (Claude Sonnet 4.6) -- Re-anchor starttime to start (mirrors duetime/due block above)
        // Fixes stale starttime after repeating task advances start to next occurrence.

        if(typeof task.starttime != 'undefined' && task.starttime !== null && task.starttime > 0) {

            if(typeof task.start != 'undefined' && task.start !== null && task.start > 0) {

                let tempDateString = TaskService.getStringFromMillis(task.start, 'MM/DD/YYYY')
                // 20260604 -- Copilot (Claude Sonnet 4.6) -- Omit ZZ so Moment uses the target date's DST offset, not the stale one
                let tempTimeString = TaskService.getStringFromMillis(task.starttime, 'HH:mm a')

                task.starttime = TaskService.getMillisFromString(tempDateString + ' ' + tempTimeString, false, 'MM/DD/YYYY HH:mm a')

            } else {

                // starttime with no start is orphaned — clear it
                task.starttime = null

            }
        }

        // Calculate the date/time to send the reminder if both the due date
        // and remider frequency are set.

        if(typeof task.remind != 'undefined' && task.remind !== null && task.remind > 0) {
        
            let base = null

            if(typeof task.duetime != 'undefined' && task.duetime !== null && task.duetime > 0) {

                base = task.duetime

            } else if(typeof task.due != 'undefined' && task.due !== null && task.due > 0) {

                base = task.due

            }

            if(typeof base != 'undefined' && base !== null && base > 0) {

            

                // Convert the reminder frequency from minutes to milliseconds
                // and subtract it from the due date.
                task.remindDate = base - (task.remind * 60 * 1000)

            

            }
        }

    }
    
    static deleteTask(taskId, token) {
        
        return axios.delete(url + '/' + taskId, {
            headers: {Authorization: `Bearer ${token}`}
        })
        
    }
    
    static deleteTasksByOwner(ownerId, token) {
        
        return axios.delete(url + '/byOwner/' + ownerId, {
            headers: {Authorization: `Bearer ${token}`}
        })
        
    }

    
    
    // Converts a date or date/time String into milliseconds since the epoch.
    // Note: If value of iso8601 is a number, its value is return without
    // regard for stripTime or format.
    static getMillisFromString(iso8601, stripTime, format) {
        
        // console.log('getMillisFromString: ' + iso8601)
        
        let retVal = null

        if(isNaN(iso8601))
        {
            // console.log('getMillisFromString: ' + iso8601 + ' --> ' + format)

            let moment = require('moment')

            if((typeof format == 'undefined' || format === null || format == '')) {
                format = 'YYYY-MM-DD'
            }

            

            let originalMoment = moment(iso8601, format)

            if(stripTime) {
                originalMoment.hour(0)
                originalMoment.minute(0)
                originalMoment.second(0)
                originalMoment.millisecond(0)
            }

            retVal = originalMoment.format('x')
            
        } else {
            retVal = Number(iso8601)
        }

        // console.log('getMillisFromString: ' + iso8601 + ' --> ' + format + ' = ' + retVal)
        return Number(retVal)
    }

    static getStringFromMillis(millis, format) {

        let retVal = ''

        if((typeof format == 'undefined' || format === null || format == '')) {
            format = 'YYYY-MM-DD'
        }

        if(millis > 0) {
            
            retVal = moment(Number(millis)).format(format)
        } else {
            retVal = ''
        }

        // console.log('getStringFromMillis: ' + millis + ' -> ' + format + ' = ' + retVal)

        return retVal

    }
    
    static getTask(ownerId, taskId, token) {
        
        ////console.log('TaskService.getTask')

        return axios.get(url_v2 + "/" + taskId, {
            headers: {Authorization: `Bearer ${token}`}
        })
    }

    static getTasks(ownerId, filter, token) {
        
        return axios.get(url + "/" + ownerId + "/" + encodeURIComponent(JSON.stringify(filter)), {
            headers: {Authorization: `Bearer ${token}`}
        })
    }

    static getTasksForGTDInbox(token) {
        
        return axios.get(`${url_v3}/tasks/gtd/inbox`, {
            headers: {Authorization: `Bearer ${token}`}
        })
    }
    
    static buildFilter(filterItems) {

        // 20200401 -- ZWS -- General method for parsing filter items; either
        // user- or system-defined.

        ////console.log('TaskService.buildFilter - filterItems = ' + JSON.stringify(filterItems))
        
        let pendingFilter = {
            a: [],
            b: [],
            c: [],
            d: [],
            e: [],
            f: [],
            g: [],
            h: [],
            i: [],
            j: [],
            k: [],
            l: [],
            m: [],
            n: [],
            o: [],
            p: [],
            q: [],
            r: [],
            s: [],
            t: [],
            u: [],
            v: [],
            w: [],
            x: [],
            y: [],
            z: [],
        }
        
        let refinedFilter = {}
        //refinedFilter._id = filter._id

        if(typeof filterItems != 'undefined' && filterItems !== null) {

        
        
            filterItems.forEach((item, index, array) => {

                if((typeof item.group != 'undefined' && item.group !== null)
                && (typeof item.field != 'undefined' && item.field !== null)
                && (typeof item.operator != 'undefined' && item.operator !== null)
                && (typeof item.value != 'undefined' && item.value !== null)) {

                    // Process text fields that contain known values
                    if(item.field == 'completed'
                    || item.field == 'context'
                    || item.field == 'folder'
                    || item.field == 'priority'
                    || item.field == 'star'
                    || item.field == 'status') {
                        
                        if(item.value != 'A' && item.value != 'All' && item.value != 'ALL') {
                            // 20260128 -- Copilot (Claude Sonnet 4.5) -- Case-insensitive matching for priority/status
                            // WHY: Database may have inconsistent casing (High vs high, Medium vs medium)
                            let crit = {}
                            let field = {}
                            let criteria = {}
                            criteria['$regex'] = '^' + item.value + '$'
                            criteria['$options'] = 'i'
                            field[item.field] = criteria
                            pendingFilter[item.group].push(field)
                        }    
                    }
                    // Process text fields without a known value
                    else if(item.field == 'title'
                    || item.field == 'notes') {
                        
                        
                        let field = {}
                        let criteria = {}
                        criteria['$regex'] = item.value
                        criteria['$options'] = 'i'

                        field[item.field] = criteria
                        pendingFilter[item.group].push(field)

                        // WORKS: {'title': {'$regex': 'crm', '$options': 'i'}}

                    // Process date fields
                    } else if(item.field == 'added'
                    || item.field == 'completedDate'
                    || item.field == 'due'
                    || item.field == 'start') {

                        let field = {}
                        let criteria = {}

                        criteria[item.operator] = this.getMillisFromString(item.value, false, 'YYYY-MM-DD')
                        // console.log(criteria[item.operator])
                        
                        // Require the field to have a value
                        criteria['$ne'] = ''

                        // Don't add another $gt if the user already defined one
                        if(item.operator != '$gt') {
                            criteria['$gt'] = 0
                        }
                        
                        
                        field[item.field] = criteria
                        pendingFilter[item.group].push(field)

                    }
                }
            });
        }

        ////console.log('pendingFilter = ' + JSON.stringify(pendingFilter))

        let ors = []
        Object.entries(pendingFilter).forEach(([key, value]) => {
            
            if(value.length > 0) {
                ors.push({'$and': value})
            }
            
            
        });

        if(ors.length > 0) {
            refinedFilter.$or = ors
        }
        
        //////console.log('Setting user-defined filter = ' + JSON.stringify(filter))

        return refinedFilter

    }
    
    static refineTaskFilter(filter, quickFilters, offset) {
        
        var moment = require('moment')
        
        ////console.log('TaskService.refineTaskFilter - starting with filter = ' + JSON.stringify(filter))

        if(typeof filter.quickFilter != 'undefined' && filter.quickFilter !== null && filter.quickFilter >= 0) { 
            
            let filterItems = []

            if(filter.quickFilter == 0) {

                //
                // Get Organized
                //

                // A: Completed == N
                let item = {}
                item.group = 'a'
                item.field = 'completed'
                item.operator = '$eq'
                item.value = 'N'
                filterItems.push(item)

                // A: Start Date < TODAY
                item = {}
                item.group = 'a'
                item.field = 'start'
                item.operator = '$lt'
                item.value = Number(moment().startOf('day').format('x'))
                filterItems.push(item)

                // B: Completed == N
                item = {}
                item.group = 'b'
                item.field = 'completed'
                item.operator = '$eq'
                item.value = 'N'
                filterItems.push(item)

                // B: Due Date < TODAY
                item = {}
                item.group = 'b'
                item.field = 'due'
                item.operator = '$lt'
                item.value = Number(moment().startOf('day').format('x'))
                filterItems.push(item)


            } else if(filter.quickFilter == 1) {
                
                
                //
                // Today's Focus
                //

                // A: Completed == N
                let item = {}
                item.group = 'a'
                item.field = 'completed'
                item.operator = '$eq'
                item.value = 'N'
                filterItems.push(item)

                // A: Start Date == TODAY

                let today = (moment().startOf('day'))
                today.add(offset, 'days')
                item = {}
                item.group = 'a'
                item.field = 'start'
                item.operator = '$eq'
                item.value = Number(today.format('x'))
                filterItems.push(item)

                // B: Completed == N
                item = {}
                item.group = 'b'
                item.field = 'completed'
                item.operator = '$eq'
                item.value = 'N'
                filterItems.push(item)

                // B: Due Date == TODAY
                item = {}
                item.group = 'b'
                item.field = 'due'
                item.operator = '$eq'
                item.value = Number(today.format('x'))
                filterItems.push(item)

            } else if(filter.quickFilter == 2) {
                
                
                //
                // This Week
                //

                // A: Completed == N
                let item = {}
                item.group = 'a'
                item.field = 'completed'
                item.operator = '$eq'
                item.value = 'N'
                filterItems.push(item)

                // 20260128 -- Copilot (Claude Sonnet 4.5) -- Changed to start week on Sunday (US standard)
                // WHY: Previous logic started on Monday, excluding Sunday tasks from "This Week"
                let startOfWeek = moment().startOf('week')
                startOfWeek.add(offset * 7, 'days')
                
                let endOfWeek = moment().startOf('week')
                endOfWeek.add(offset * 7, 'days')
                endOfWeek.add(7, 'days')

                // A: Start Date >= Start of Week
                item = {}
                item.group = 'a'
                item.field = 'start'
                item.operator = '$gte'
                item.value = Number(startOfWeek.format('x'))
                filterItems.push(item)

                // B: Start Date < Start of Week + 7 days
                item = {}
                item.group = 'a'
                item.field = 'start'
                item.operator = '$lt'
                item.value = Number(endOfWeek.format('x'))
                filterItems.push(item)

                // B: Completed == N
                item = {}
                item.group = 'b'
                item.field = 'completed'
                item.operator = '$eq'
                item.value = 'N'
                filterItems.push(item)

                // B: Due Date >= Start of Week
                item = {}
                item.group = 'b'
                item.field = 'due'
                item.operator = '$gte'
                item.value = Number(startOfWeek.format('x'))
                filterItems.push(item)
                
                // B: Due Date < Start of Week + 7 days
                item = {}
                item.group = 'b'
                item.field = 'due'
                item.operator = '$lt'
                item.value = Number(endOfWeek.format('x'))
                filterItems.push(item)

                

            } else if(filter.quickFilter == 3) {

                //
                // Overdue
                //
    
                // A: Completed == N
                let item = {}
                item.group = 'a'
                item.field = 'completed'
                item.operator = '$eq'
                item.value = 'N'
                filterItems.push(item)
    
                // A: Start Date < TODAY
    
                let today = (moment().startOf('day'))
                item = {}
                item.group = 'a'
                item.field = 'start'
                item.operator = '$lt'
                item.value = Number(today.format('x'))
                filterItems.push(item)
    
                // A: Due Date < TODAY
                item = {}
                item.group = 'a'
                item.field = 'due'
                item.operator = '$lt'
                item.value = Number(today.format('x'))
                filterItems.push(item)
    
                // B: Completed == N
                item = {}
                item.group = 'b'
                item.field = 'completed'
                item.operator = '$eq'
                item.value = 'N'
                filterItems.push(item)
    
                // B: Start Date < TODAY
    
                today = (moment().startOf('day'))
                item = {}
                item.group = 'b'
                item.field = 'start'
                item.operator = '$lt'
                item.value = Number(today.format('x'))
                filterItems.push(item)
    
                // B: Due Date is empty
                item = {}
                item.group = 'b'
                item.field = 'due'
                item.operator = '$eq'
                item.value = ''
                filterItems.push(item)
    
                // C: Completed == N
                item = {}
                item.group = 'c'
                item.field = 'completed'
                item.operator = '$eq'
                item.value = 'N'
                filterItems.push(item)
    
                // C: Start Date is empty
    
                today = (moment().startOf('day'))
                item = {}
                item.group = 'c'
                item.field = 'start'
                item.operator = '$eq'
                item.value = ''
                filterItems.push(item)
    
                // C: Due Date < TODAY
                item = {}
                item.group = 'c'
                item.field = 'due'
                item.operator = '$lt'
                item.value = Number(today.format('x'))
                filterItems.push(item)
    
                filter.refinedFilter = this.buildFilter(filterItems)
    
            
            }
            
            ////console.log('TaskService.refineTaskFilter - [system]filterItems = ' + JSON.stringify(filterItems))
            filter.refinedFilter = this.buildFilter(filterItems)
        
        } else {

            // 20200401 -- ZWS -- The following call existed in the previous
            // logic.  I'm not certain why it was needed and it looks 
            // non-sensical.  I keep it here to remind myself in case there's
            // a problem.
            // refinedFilter._id = filter._id

            filter.refinedFilter = this.buildFilter(filter.filterItems)

        }
        
        ////console.log('TaskService.refineTaskFilter - filter = ' + JSON.stringify(filter))
        
        return filter

    }
    
    static setSystemValues(task) {

        let newTask = task

        if(typeof task._id == 'undefined' || task._id === null) {

            newTask.owner = store.getters.getUser._id
            newTask.added = Date.now()
            newTask.via = createdBy[0]
            newTask.id = UUIDService()
            
            if(typeof newTask.star == 'undefined' || newTask.star === null) {
                newTask.star = 'N'
            }

            if(typeof newTask.completed == 'undefined' || newTask.completed === null) {
                newTask.completed = 'N'
            }

        }

        
        
        

        if(typeof newTask.parent != 'undefined' && newTask.parent !== null) {
            newTask.parent = newTask.parent
        }

        return newTask


    }

    static setUserValues(task, taskPrefs) {

        //////console.log('setUserValues applying: ' + JSON.stringify(taskPrefs))
        
        if(typeof taskPrefs != 'undefined' && !(taskPrefs === null)) {

            if(typeof taskPrefs.context == 'undefined' || taskPrefs.context === null) {
                    
                task.context = taskPrefs.context
            }

            if(typeof taskPrefs.folder == 'undefined' || taskPrefs.folder === null) {
                    
                task.folder = taskPrefs.folder
            }

            if(typeof taskPrefs.priority == 'undefined' || taskPrefs.priority === null) {
                    
                task.priority = taskPrefs.priority
            }

            if(typeof taskPrefs.status == 'undefined' || taskPrefs.status === null) {
                    
                task.status = taskPrefs.status
            }

            if(typeof taskPrefs.start != 'undefined' && !(taskPrefs.start === null) && taskPrefs.start > 0) {
                
                let newDate;
                
                if(typeof task.start == 'undefined' || task.start === null || task.start == 0) {
                    newDate = moment()
                    newDate.set('hour', 0)
                    newDate.set('minute', 0)
                    newDate.set('second', 0)
                    newDate.set('millisecond', 0)

                    newDate.add(taskPrefs.start, 'days')
                } else {
                    newDate = moment(task.start, 'x')
                    newDate.set('hour', 0)
                    newDate.set('minute', 0)
                    newDate.set('second', 0)
                    newDate.set('millisecond', 0)
                }
                
                //////console.log('TaskService.setUserValues start is ' + newDate.format('YYYY-MM-D HH:mm:ss Z z'))

                

                //////console.log('TaskService.setUserValues start is now ' + newDate.format('YYYY-MM-D HH:mm:ss Z z'))

                task.start = Number(newDate.format('x'))
            }

            if(typeof taskPrefs.due != 'undefined' && !(taskPrefs.due === null) && taskPrefs.due > 0) {
                
                let newDate;
                
                if(typeof task.due == 'undefined' || task.due === null || task.due == 0) {
                    newDate = moment()
                    newDate.set('hour', 0)
                    newDate.set('minute', 0)
                    newDate.set('second', 0)
                    newDate.set('millisecond', 0)

                    newDate.add(taskPrefs.due, 'days')
                } else {
                    newDate = moment(task.due, 'x')
                    newDate.set('hour', 0)
                    newDate.set('minute', 0)
                    newDate.set('second', 0)
                    newDate.set('millisecond', 0)
                }
                
                //////console.log('TaskService.setUserValues due is ' + newDate.format('YYYY-MM-D HH:mm:ss Z z'))
            
                

                //////console.log('TaskService.setUserValues due is now ' + newDate.format('YYYY-MM-D HH:mm:ss Z z'))

                task.due = Number(newDate.format('x'))
            }
            
            
            

        }
        
        



    }

    static translateDateForUnix(inputDate, dateFormat) {
        let translatedDate = new Date(inputDate)
        let sinceEpoch = translatedDate.getTime()
        sinceEpoch = sinceEpoch
        //////console.log(inputDate + ' -> ' + translatedDate.toString() + ' -> ' + sinceEpoch)
        return sinceEpoch
    }
    
    static translateiCalRRuleForDisplay(value) {
        
        if(!(value===null) & (typeof value !== 'undefined') & !(value=='')) {

               
            let tempValue = ''
            let tempValue2 = ''

            // Remove Toodledo specific RRules.
            tempValue = value.replace(";FROMCOMP", "")
            tempValue = tempValue.replace(";FASTFORWARD", "")

            let rule = rrulestr('DTSTART:20120201T023000Z\nRRULE:' + tempValue.trim())
            return rule.toText()

        } else {
            return ''
        }

    }

    
    
    static translateUnixDate(value) {
        
        let newValue = ''
        let retValue = ''
        if(value > 0) {
            newValue = new Date(parseInt(value))
            retValue = newValue.getFullYear () + '-' +
                months2[newValue.getMonth()] +  '-' +
                ('' + newValue.getDate()).padStart(2, '0')

          } else {
            retValue = ''
          }

        return retValue
    }
    
    
    static translateUnixDateAndTime(value, valueWithTime) {
        
        let time = ''

        let newTime = ''
        let retTimeValue = ''
        if(!(valueWithTime===null) & valueWithTime > 0) {

            newTime = new Date(parseInt(valueWithTime))
            retTimeValue = ('' + newTime.getHours()).padStart(2, 0) + ":" +
                ('' + newTime.getMinutes()).padStart(2, 0) + ":" + 
                ('' + newTime.getSeconds()).padStart(2, 0)

        } else {
            retTimeValue = '03:14:59'
        }
        
        let newValue = ''
        let retValue = ''
        if(value > 0) {
            newValue = new Date(parseInt(value))
            retValue = newValue.getFullYear () + '-' +
                months2[newValue.getMonth()] +  '-' +
                ('' + newValue.getDate()).padStart(2, '0') +
                'T' + retTimeValue;

          } else {
            retValue = ''
          }

        return retValue
    }

    static translateUnixDateForDisplay(value, valueWithTime) {
        
        let time = ''

        let newTime = ''
        let retTimeValue = ''
        if(!(valueWithTime===null) & valueWithTime > 0) {

            newTime = new Date(parseInt(valueWithTime))
            retTimeValue = ('' + newTime.getHours()).padStart(2, 0) + ":" +
                ('' + newTime.getMinutes()).padStart(2, 0) + ":" + 
                ('' + newTime.getSeconds()).padStart(2, 0)

        }
        
        let newValue = ''
        let retValue = ''
        if(value > 0) {
            newValue = new Date(parseInt(value))
            retValue = ('' + newValue.getDate()).padStart(2, '0') +  '-' +
                months[newValue.getMonth()] + '-' +
                newValue.getFullYear () + 
                ' ' + retTimeValue;

          } else {
            retValue = ''
          }

        return retValue
    }

    static translateUnixTime(valueWithTime) {
        
        let time = ''

        let newTime = ''
        let retTimeValue = ''
        if(!(valueWithTime===null) & valueWithTime > 0) {

            newTime = new Date(parseInt(valueWithTime))
            retTimeValue = ('' + newTime.getHours()).padStart(2, 0) + ":" +
                ('' + newTime.getMinutes()).padStart(2, 0) + ":" + 
                ('' + newTime.getSeconds()).padStart(2, 0)

        } else {
            retTimeValue = '03:14:59'
        }
        
        return retTimeValue
    }

    

    

    
    
    static updateTask(task, token) {
        
        return axios.put(url, {
            data: task
        }, {
            headers: {Authorization: `Bearer ${token}`}
        })
        
    }

    



}

export default TaskService; 